/** The app's one Store, created on first use with the bundled data and IndexedDB. */
import { BUNDLED } from './bundled'
import { regionFromLocale } from './settings'
import { Store } from './store'

let store: Store | null = null

export function getStore(): Store {
  if (!store) {
    const locale = typeof navigator !== 'undefined' ? navigator.language : undefined
    const localeRegion = regionFromLocale(locale)
    store = new Store({ bundled: BUNDLED, ...(localeRegion ? { localeRegion } : {}) })
    void store.load()
  }
  return store
}
